import { GridkyType } from '@app/dashboard/shared/ea-gridky/ea-gridky-header/ea-gridky-header.component';
import {
  SimulationInformations,
  SimulationParameters,
} from '@app/dashboard/shared/ea-simulation-parameters/ea-simulation-parameters.component';

export enum SimulationType {
  FCPI = 'FCPI',
  FIP = 'FIP',
  GIRARDIN = 'GIRARDIN',
  SOFICA = 'SOFICA',
  PINEL = 'PINEL',
  LMNP = 'LMNP',
  SCPI = 'SCPI',
  ASSURANCE_VIE = 'ASSURANCE_VIE',
  PER = 'PER',
  LOAN = 'LOAN',
  'INVESTISSEMENT PME' = 'PME',
  FISCALITY_RENT = 'FISCALITY_RENT',
}

export interface SimulationQuery<PARAMETER> {
  type: SimulationType;
  parameters: PARAMETER;
}

export interface SimulationResult<PARAMETER, RESULT>
  extends SimulationQuery<PARAMETER> {
  id?: number;
  accountId: number;
  creationDate: Date;
  completeParameters: PARAMETER;
  result: RESULT;
  ownerIds?: number[];
}

export abstract class Simulation<PARAMETER, RESULT> {
  groups: Array<SimulationParameters | SimulationInformations>;
  simulation: SimulationResult<PARAMETER, RESULT>;

  get parameters(): PARAMETER {
    return this.simulation?.parameters;
  }

  get completeParameters(): PARAMETER {
    return this.simulation?.completeParameters;
  }

  get result(): RESULT {
    return this.simulation?.result;
  }
}

export interface GridKySearchCriteria {
  project?: string;
  lmnpTypes?: string;
  distanceSearchLatitude?: number;
  distanceSearchLongitude?: number;
  distanceSearchRadiusKm?: number;
  priceMin?: number;
  priceMax?: number;
  globalScoreMin?: number;
}

export interface GridkyProduct {
  abilityToFillResidence?: number;
  cellarSurface?: number;
  createdAt?: string;
  deletedAt?: boolean;
  fiscalTypes?: any[];
  floor?: number;
  furniturePriceInclTax?: number;
  gardenSurface?: number;
  globalScore?: number;
  hasCellar?: number;
  hasGarden?: number;
  hasLoggia?: number;
  hasOption?: number;
  hasParking?: number;
  hasTerrace?: number;
  id?: number;
  isReducedTva?: boolean;
  lmnpType?: [GridkyType];
  loggiaSurface?: number;
  m2Price?: number;
  managerStrength?: number;
  maxRent?: number;
  mediaUrl?: any;
  neighborhoodAttractivity?: any;
  netRentProfitability?: number;
  orientations?: any[];
  otherSurface?: boolean;
  parkingPriceInclTax?: number;
  potentialCapitalGain?: number;
  priceInclTax?: number;
  priceWithParkingInclTax?: number;
  program?: GridkyProgram;
  projects?: GridkyType[];
  reference?: string;
  rentProfitability?: number;
  rentalProfitabilityPostConsolidation?: any;
  rentalSecurity?: any;
  resaleEasiness?: any;
  reserved?: boolean;
  status?: string;
  surface?: number;
  taxPerformance?: number;
  terraceSurface?: number;
  type?: string;
  typology?: string;
  updatedAt?: string;
  weightedSurface?: number;
  abilityToFillResidenceExplanation?: string;
  managerStrengthExplanation?: string;
  netRentProfitabilityExplanation?: string;
  neighborhoodAttractivityExplanation?: string;
  documents?: any[];
}

export interface GridkyProgram {
  abilityToFillResidence?: number;
  address?: string;
  city?: string;
  cityData?: CityData;
  createdAt?: string;
  deletedAt?: any;
  deliveryDate?: string;
  deliveryQuarter?: number;
  deliveryYear?: number;
  description?: any;
  fiscalTypes?: [];
  globalScore?: number;
  id?: number;
  immediateDelivery?: false;
  inseeCode?: any;
  latitude?: number;
  lmnpManager?: any;
  lmnpTypes?: string[];
  longitude?: number;
  managerStrength?: number;
  minimumPriceByTypo?: any;
  name?: string;
  neighborhoodAttractivity?: any;
  netRentProfitability?: number;
  photos?: string[];
  pinelAreaCode?: any;
  postalCode?: string;
  potentialCapitalGain?: any;
  projects?: string[];
  promoter?: string;
  propertyCount?: number;
  propertyTypes?: string[];
  published?: true;
  rentProfitability?: number;
  rentalProfitabilityPostConsolidation?: any;
  rentalSecurity?: any;
  resaleEasiness?: any;
  taxPerformance?: number;
  updatedAt?: string;
  url?: string;
}

export interface CityData {
  childNumber?: number;
  cityDescription?: string;
  croissancePercent?: number;
  departmentName?: string;
  departmentNumber?: string;
  manNumber?: number;
  menageNumber?: number;
  popNumber?: number;
  popNumberMinus5Year?: number;
  regionName?: string;
  studentNumber?: number;
  womenNumber?: number;
}
